import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "asterikToHtmlTags"
})
export class AsterikToHtmlTags implements PipeTransform {
	transform(input: String, replaceFrom: any, replaceTo: any): any {
		if (replaceFrom == null || replaceTo == null) {
			return input;
		}

		return input.replace(replaceFrom, replaceTo);
	}
}
